export default __webpack_public_path__ + "static/transformImg1-4b5cfb2c7a33721db278d322add2ed34.png";